import { isFinite } from 'lodash';
import storage from '@core/lib/storage/storage';

/**
 * List of migrations
 */
const _migrations = {
  1: () => {
    storage.clear();
  },
  2: () => {
    storage.remove(/new-dash-modal-/);
  },
  3: () => {
    storage.remove(/sdk_version_/);
  },
  4: () => {
  storage.remove(/sdk_version_/);
},
};

/**
 * Executes the storage migrations sequentially
 *
 * @param {Number} currentVersion
 */
function run(currentVersion) {
  for (
    let i = self._getStoredVersion(currentVersion);
    i < currentVersion;
    i++
  ) {
    self._runMigration(i + 1);
  }

  storage.put('version', currentVersion);
}

/**
 * @param {Number} currentVersion
 * @returns {Number}
 */
function _getStoredVersion(currentVersion) {
  try {
    const stored = parseInt(storage.get('version'), 10);
    if (!isFinite(stored) || stored > currentVersion) {
      throw 'invalid';
    }

    return stored;
  } catch (e) {
    return -1;
  }
}

/**
 * Executes a migration for a given version
 *
 * @param {Number} version
 */
function _runMigration(version) {
  _migrations[version] && _migrations[version]();
}

const self = {
  run,
  _migrations,
  _getStoredVersion,
  _runMigration
};

export default self;
